// extracted by mini-css-extract-plugin
export default {"footer":"_WQbgP","footer__links":"_w1Szs","footer__copyright":"_EXS8J"};